import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { useLanguage } from "../../../i18n/useLanguage";
import { CompareResults } from "../../../queries/useBuildComparison";
import { TirePartItem } from "../../../queries/useSearchTiresByVehicle";
import { KeyValue } from "../../../ui/KeyValue/KeyValue";
import { PriceDisplay } from "../../../ui/PriceDisplay/PriceDisplay";
import { gridCellClass } from "./TireComparisonGrid";
import { selectPricingContext } from "./selectPricingContext";
import { useShouldRenderPricing } from "./useShouldRenderPricing";

type ProductInfoProps = {
  part: TirePartItem;
  partQuantity: CompareResults["partQuantity"];
};

export const AdditionalCosts: FunctionComponent<ProductInfoProps> = ({
  part,
  partQuantity,
}) => {
  const { t } = useTranslation();
  const [language] = useLanguage();
  const { lineItemList = [] } = selectPricingContext(partQuantity);
  return (
    <div className={gridCellClass}>
      {useShouldRenderPricing(part) && lineItemList.length > 0
        ? lineItemList.map(({ lineItemId, price, qty, title }) => (
            <KeyValue
              className="justify-between"
              key={lineItemId}
              keyClassName="truncate"
              valueClassName="whitespace-nowrap"
            >
              <>
                {qty} &ndash; {title[language]}:
              </>
              <PriceDisplay>{price}</PriceDisplay>
            </KeyValue>
          ))
        : t("compare.notAvailable")}
    </div>
  );
};
